<head>
    <style>
        .my-pagination /deep/ .ngx-pagination .current {
            font-family: "Graphik SemiBold";
            font-weight: normal;
            font-style: normal;
            font-display: swap;
            color: #265d6e;
            background: transparent;
        }
    </style>
</head>
<div class="container-fluid">
    <div id="success-alert" class="alert alert-success alert-dismissible fade show mt-3" role="alert">
        <strong id="videoTitle"></strong> <span id="message"> </span>
        <button (click)="closeSuccessAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div id="error-alert" class="alert alert-danger alert-dismissible fade show mt-3" role="alert">
        <span id="error-message"></span>
        <button (click)="closeErrorAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <nav class="navbar navbar-light sub-nav">
        <div class="left-nav">
            <a class="navbar-brand">
                <h5 class="Ws-subtitle">{{constants.WINDOW_UPLOADED_TXT}}</h5>
            </a>
            <div class="form-check-uploaded">
                <input type="checkbox" class="uploaded-form-check-input" id="check11" (change)=onCheckedAll($event)>
                <label class="uploaded-form-check-label" for="check11">{{constants.SELECT_TXT}}&nbsp;&nbsp;({{videoList.length}})</label>
            </div>
            <button *ngIf="liveVideo" (click)="onclickGenerateTxt()" class="button-generate">
                {{constants.CREATE_TXT}}</button>
            <!-- <button *ngIf="liveVideo" [disabled]="isProcessing" (click)="onClickMakeOffline()" class="button-generate">
                <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                Make Offline</button> -->
            <span class="d-flex justify-content-center">
                <input type="checkbox" id="liveFilter" class="custom-checkbox" [(ngModel)]="latestVideosOnly"
                    (change)="onClickOnShowLatestVideosOnly()" [disabled]="isLoading">
                <label for="liveFilter" class="checkbox-label"><svg width="16" height="14" viewBox="0 0 20 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 6.8L7.17647 14L18 2" stroke="white" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>&nbsp;&nbsp;Latest Videos Only</label>
            </span>
        </div>
        <div class="right-nav">
            <a [routerLink]="['/admin/uploaded/1']">
                <p id="offline-button" class="live-buttons">Offline
                    Videos</p>
            </a>
            <a [routerLink]="['/admin/uploaded']">
                <p id="live-button" class="live-buttons-active">
                    {{constants.LIVE_VIDEO_TXT}}
                </p>
            </a>
            <span class="navbar-text justify-content-end">
                <input id="search" class="search" type="text" placeholder="search" (ngModelChange)="Search()"
                    [(ngModel)]="videoTitle" (ngModelChange)="Search()">
            </span>
        </div>
    </nav>
    <div class="row uploaded-window" *ngIf="isLoading">
        <div *ngFor="let item of uploadSkeltonArray" class="col-3 uploaded-window-col">
            <img style="width: 100%;" src="{{item}}" alt="">
        </div>
    </div>
    <div class="row uploaded-window" *ngIf="!isLoading">
        <div id="empty"></div>
        <div class="col-3 uploaded-window-col" id="{{item.videoId}}-card"
            *ngFor="let item of liveVideos |filter:videoTitle | paginate: { itemsPerPage: 250, currentPage: p }">
            <div class="card uploaded-card">
                <div class="card-body uploaded-card-body row">
                    <div class="col uploaded-card-img-container">
                        <input class="card-checkbox" type="checkbox" [checked]="isChecked" id="{{item.videoId}}-live"
                            (change)=onSelectTbleRow(item,$event)>
                        <label for="{{item.videoId}}-live"><img class="uploaded-card-img" src="{{item.thumbnail}}"
                                alt=""></label>
                    </div>
                    <div class="col uploaded-card-title-container">
                        <div class="upload-card-title">
                            <p class="uploaded-title" (click)="onClickVideoTitle(item,$event)" id="{{item.videoId}}">
                                {{item.cityLocation}} </p>
                        </div>
                        <p class="upload-card-view">{{item.stats}} views </p>
                        <!-- <p class="upload-card-bookamrk">123 bookmarks </p> -->
                        <p (click)="onClickName(item)" class="upload-card-author">{{item.author}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <nav class="navbar navbar-priamry footer live-footer">
        <pagination-controls class="my-pagination" (pageChange)="p = $event"></pagination-controls>
    </nav>
</div>